/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  IconButton,
} from '@mui/material';
import Icon from '@/components/Icon';
import { selectModal } from '@/store/selectors';
import { closeModal } from '@/store/slices/modal';
import AddPrinterForm from '@/components/Forms/AddPrinterForm';

const boxStyle = {
  position: 'absolute',
  height: '555px',
  width: '500px',
  backgroundColor: '#fff',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  p: 4,
};

const SavePrinter = () => {
  const { defaultPrinter } = useSelector(selectModal);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'defaultPrinter' }));
  };

  return (
    <div>
      <Modal
        open={defaultPrinter}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={defaultPrinter} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  lineHeight: '40px',
                  fontWeight: 700,
                  fontFamily: 'Fellix',
                  fontSize: '32px',
                  color: '#0A083A',
                }}
              >
                Add Printer
              </Typography>
              <Box>
                <IconButton
                  onClick={handleModalClose}
                  sx={{
                    width: '45px',
                    height: '45px',
                    p: '12px 16px',
                    '& svg path': {
                      fill: '#0043B9',
                    },
                  }}
                >
                  <Icon icon="cancel" width={45} height={45} />
                </IconButton>
              </Box>
            </Box>

            <AddPrinterForm />
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default SavePrinter;
